import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api, { formatPrice, formatDate } from '../utils/api';
import './Orders.css';

const STATUS_COLORS = {
  pending: 'status-pending',
  processing: 'status-processing',
  shipped: 'status-shipped',
  delivered: 'status-delivered',
  cancelled: 'status-cancelled',
  refunded: 'status-refunded',
};

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/orders/my')
      .then(r => setOrders(r.data.orders))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-center" style={{ minHeight: '60vh' }}><div className="spinner"></div></div>;

  return (
    <div className="orders-page container">
      <h1 className="section-title" style={{ marginBottom: 32 }}>My Orders</h1>

      {orders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📦</div>
          <h3>No orders yet</h3>
          <p>Your orders will appear here once you make a purchase.</p>
          <Link to="/shop" className="btn btn-primary" style={{ marginTop: 20 }}>Start Shopping</Link>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map(order => (
            <div key={order._id} className="order-card card">
              <div className="order-card-header">
                <div>
                  <p className="order-num">Order #{order._id.slice(-8).toUpperCase()}</p>
                  <p className="order-date">{formatDate(order.createdAt)}</p>
                </div>
                <span className={`status-badge ${STATUS_COLORS[order.orderStatus]}`}>
                  {order.orderStatus}
                </span>
              </div>

              <div className="order-card-items">
                {order.orderItems.slice(0, 3).map(item => (
                  <img key={item._id} src={item.image} alt={item.name} className="order-thumb" title={item.name} />
                ))}
                {order.orderItems.length > 3 && (
                  <div className="order-thumb-more">+{order.orderItems.length - 3}</div>
                )}
                <div className="order-card-info">
                  <p>{order.orderItems.length} item{order.orderItems.length > 1 ? 's' : ''}</p>
                  <p className="order-total">{formatPrice(order.totalPrice)}</p>
                </div>
              </div>

              <div className="order-card-footer">
                <span className={`payment-status ${order.isPaid ? 'paid' : 'unpaid'}`}>
                  {order.isPaid ? '✓ Paid' : '⏳ Payment Pending'}
                </span>
                <Link to={`/orders/${order._id}`} className="btn btn-secondary btn-sm">
                  View Details →
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
